<!-- 预约管理 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="addReservation()" v-if="permission.addReservation">{{
                    permission.addReservation
                }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">预约号</div>
                <el-input
                    style="width: 250px"
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.rCode"
                    v-filter-special-char="searchData.rCode"
                    placeholder="请输入预约号"
                ></el-input>
                <div class="search-name">车主</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.key" v-filter-special-char="searchData.key" placeholder="请输入车主名称"></el-input>
                <div class="search-name">车牌号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.cNum" v-filter-special-char="searchData.cNum" placeholder="请输入车牌号"></el-input>
                <div class="search-name">预约时间</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                border
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; cursor: pointer"
                highlight-current-row
            >
                <el-table-column width="190px" prop="ReservationCode" label="预约号"></el-table-column>
                <el-table-column width="100px" prop="RCarNum" label="车牌号"></el-table-column>
                <el-table-column min-width="200" prop="BrandSeries" label="车型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="RName" label="车主名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ReservationTime" label="预约类型" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.ReservationType | ReservationTypeHandle }}</template>
                </el-table-column>
                <el-table-column prop="ReservationTime" label="预约时间" width="250px" show-overflow-tooltip></el-table-column>
                <el-table-column width="150px" prop="StateName" label="检修状态" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.State | StateHandle }}</template>
                </el-table-column>
                <el-table-column width="150px" prop="Source" label="来源" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.Source == 0 ? '车主' : scope.row.Source == 1 ? '车回佳' : '自主创建' }}</template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button @click="refuse(scope.row, scope.$index)" type="text" size="small" v-if="scope.row.State == 10 && permission.reject">{{
                                permission.reject
                            }}</el-button>
                            <el-button
                                @click="cancel(scope.row, scope.$index)"
                                type="text"
                                size="small"
                                v-if="scope.row.Source == 2 && scope.row.State != 5 && scope.row.State != 40 && permission.cancel"
                                >{{ permission.cancel }}</el-button
                            >
                            <el-button @click="entpConfirmReservation(scope.row, scope.$index)" type="text" size="small" v-if="scope.row.State == 10 && permission.confirm">{{
                                permission.confirm
                            }}</el-button>
                            <el-button
                                @click="gotoCreateResult(scope.row, scope.$index)"
                                type="text"
                                size="small"
                                v-if="scope.row.State == 35 && scope.row.ReservationType == 0 && permission.createResult && !scope.row.RecordId"
                                >{{ permission.createResult }}</el-button
                            >
                            <el-button
                                @click="gotoCreateResult(scope.row, scope.$index)"
                                type="text"
                                size="small"
                                v-if="(scope.row.State == 35 || scope.row.State == 40) && scope.row.RecordId && permission.editResult && !scope.row.IsPay"
                                >{{ permission.editResult }}</el-button
                            >
                            <el-button @click="ShowRefuseReason(scope.row)" type="text" size="small" v-if="scope.row.State == 20 && permission.seeResult">{{
                                permission.seeResult
                            }}</el-button>
                            <el-button @click="gotoDetails(scope.row, scope.$index)" type="text" size="small" v-if="scope.row.State == 40 && permission.see">{{
                                permission.see
                            }}</el-button>
                            <el-button @click="viewClosedReason(scope.row.RId)" type="text" size="small" v-if="scope.row.State == 5">取消原因</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog title="拒绝原因" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
            <div class="dialog-content">
                <el-form :model="RefuseReasonForm" :rules="rules" ref="RefuseReasonForm" label-width="80px" size="mini">
                    <el-form-item label="原因" prop="reason">
                        <el-input v-model.trim="RefuseReasonForm.reason" autocomplete="off" type="textarea"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('RefuseReasonForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('RefuseReasonForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="取消原因" :close-on-click-modal="false" :visible.sync="dialogCancelVisible">
            <div class="dialog-content">
                <el-form :model="CancelReasonForm" :rules="rulesCancel" ref="CancelReasonForm" label-width="80px" size="mini">
                    <el-form-item label="原因" prop="reason">
                        <el-input v-model.trim="CancelReasonForm.reason" :maxlength="100" autocomplete="off" type="textarea"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetCancel('CancelReasonForm')">取 消</el-button>
                <el-button type="primary" @click="submitCancel('CancelReasonForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="预约取消原因" :close-on-click-modal="false" :visible.sync="reasonDialogVisible" @close="reasonFormData = {}">
            <div class="dialog-content">
                <el-form :model="reasonFormData" ref="reasonForm" label-width="100px" size="mini" v-loading="formloading">
                    <!-- <el-form-item label="取消人类型：">
            <label>{{reasonFormData.operatorType}}</label>
          </el-form-item>
          <el-form-item label="取消人：">
            <label>{{reasonFormData.operatorName}}</label> -->
                    <!-- </el-form-item> -->
                    <el-form-item label="取消时间：">
                        <label>{{ reasonFormData.cancelTime }}</label>
                    </el-form-item>
                    <el-form-item label="取消原因：">
                        <label>{{ reasonFormData.cancelReason }}</label>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="预约时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.sTime" :end="this.searchData.eTime"></timePicker>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="添加预约" :visible.sync="dialogVisible" width="1000px" custom-class="add-reservation" @close="showCarOwnerEdit = false">
            <div class="dialog-content" v-if="dialogVisible">
                <addReservation ref="addReservation" @chooseItem="carOwnerChooseItem" @closeDialog="closeDialog"></addReservation>
            </div>
            <div class="operator">
                <el-button size="small" class="search-btn btn-primary" @click="addCarOwner(1)">新增车主</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="addCarOwner(2)" v-if="showCarOwnerEdit">编辑车主</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="carOwnerTitle" :visible.sync="carOwnerVisible" width="1000px">
            <div class="dialog-content" v-if="carOwnerVisible">
                <carOwnerEdit
                    ref="customerEdit"
                    obj="owner"
                    :type="updateCarOwnerId"
                    :carOwnerData="updateCarOwnerId === 2 ? carOwnerData : ''"
                    @closeDialog="closeCarOwnerDialog"
                ></carOwnerEdit>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import addReservation from '@/components/business/repairMamage/addReservation';
import carOwnerEdit from '@/components/business/repairMamage/carOwnerEdit';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        timePicker,
        breadcrumb,
        elTableColumn,
        addReservation,
        carOwnerEdit
    },
    name: '',
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            timeVisible: false,
            tableData: [],
            options: [],
            searchData: {
                entpId: userMsg.EntpId,
                rCode: '',
                cNum: '',
                sTime: '',
                eTime: '',
                key: '', //车主名称
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            tableDataLength: 0,
            permission: {},
            dialogFormVisible: false,
            RefuseReasonForm: { rid: '', reason: '', index: 0 },
            rules: {
                reason: [
                    { required: true, message: '请输入原因', trigger: 'blur' },
                    { max: 100, message: '原因长度超长', trigger: 'blur' }
                ]
            },
            dialogCancelVisible: false,
            CancelReasonForm: { rid: '', reason: '', index: 0 },
            rulesCancel: {
                reason: [{ required: true, message: '请输入原因', trigger: 'blur' }]
            },
            reasonDialogVisible: false,
            dialogVisible: false,
            formloading: false,
            reasonFormData: {},
            carOwnerVisible: false, // 显示更新车主弹框
            showCarOwnerEdit: false, // 显示编辑按钮
            carOwnerTitle: '',
            updateCarOwnerId: 1, // 当前对车主的操作：1新增，2编辑
            carOwnerData: '' // 车主数据(编辑时需要传入)
        };
    },
    filters: {
        StateHandle(type) {
            if (type == 5) {
                return '预约已取消';
            } else if (type == 10) {
                return '预约待确认';
            } else if (type == 15) {
                return '婉拒处理中';
            } else if (type == 20) {
                return '婉拒已处理';
            } else if (type == 25) {
                return '车况待上传';
            } else if (type == 30) {
                return ' 车况待确认';
            } else if (type == 35) {
                return '已预约';
            } else if (type == 40) {
                return '检修完成';
            }
        },
        ReservationTypeHandle(type) {
            if (type == 0) {
                return '到店检修';
            } else if (type == 1) {
                return '上门检修';
            } else if (type == 2) {
                return '公路救援';
            }
        }
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    mounted() {
        this.getTableData();
        this.permission = this.$util.getPermission('Reservation');
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.sTime = timer.start;
            this.searchData.eTime = timer.end;
            this.handleSearch();
        },
        resetSearch() {
            this.searchData = {
                entpId: this.userMsg.EntpId,
                rCode: '',
                cNum: '',
                sTime: '',
                eTime: '',
                key: '',
                page: 1, // 当前页数
                limit: this.commonPageSize // 每页限制条数
            };
        },
        // 跳转订单详情
        gotoDetails(row) {
            this.$router.push(`/repairMamage/orderDetails?RecordId=${row.RecordId}`);
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/CustomerManagement/GetReservationList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        // 企业确认预约
        entpConfirmReservation(row, index) {
            let that = this;
            this.$util.elConfirm({
                content: '是否确认预约？',
                noMsg: true,
                confirm() {
                    let _RId = [];
                    _RId.push(row.RId);
                    that.$util
                        .axiosPost({
                            url: 'api/CustomerManagement/EntpConfirmReservation',
                            data: {
                                operatorId: that.userMsg.EmployeeId,
                                rId: _RId
                            }
                        })
                        .then(res => {
                            if (res) {
                                that.getTableData();
                            }
                        });
                }
            });
        },
        gotoCreateResult(row) {
            this.$router.push(`/repairMamage/createResult?RId=${row.RId}&UId=${row.UId}&RecordId=${row.RecordId}`);
        },
        //婉拒
        refuse(row, index) {
            this.dialogFormVisible = true;
            this.RefuseReasonForm.rid = row.RId;
            this.RefuseReasonForm.reason = '';
            this.RefuseReasonForm.index = index;
        },
        //提交婉拒原因
        submitForm(formName) {
            let that = this;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$util
                        .axiosPost({
                            url: 'api/AppletReservationOrder/RefuseReservationOrder',
                            data: {
                                RId: that.RefuseReasonForm.rid,
                                Reason: that.RefuseReasonForm.reason
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                this.getTableData();
                                this.$util.successMsg('拒绝成功');
                                this.dialogFormVisible = false;
                            } else {
                                this.$util.errorMsg('拒绝失败');
                            }
                        })
                        .catch(error => {
                            this.$util.errorMsg('拒绝失败');
                        });
                }
            });
        },
        //取消婉拒
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$refs[formName].clearValidate();
            this.dialogFormVisible = false;
        },
        //查看婉拒原因
        ShowRefuseReason(data) {
            let text = data.IsDeal == 0 ? '未处理' : data.DealResult;
            this.$alert(text, '处理结果', {
                confirmButtonText: '确定',
                callback: action => {}
            });
        },
        //取消
        cancel(row, index) {
            this.dialogCancelVisible = true;
            this.CancelReasonForm.rid = row.RId;
            this.CancelReasonForm.reason = '';
            this.CancelReasonForm.index = index;
        },
        //提交婉拒原因
        submitCancel(formName) {
            let that = this;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$util
                        .axiosPost({
                            url: 'api/CustomerManagement/CancelReservation',
                            data: {
                                RId: that.CancelReasonForm.rid,
                                Reason: that.CancelReasonForm.reason
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                this.getTableData();
                                this.$util.successMsg('取消成功');
                                this.dialogCancelVisible = false;
                            } else {
                                this.$util.errorMsg('取消失败');
                            }
                        })
                        .catch(error => {
                            this.$util.errorMsg('取消失败');
                        });
                }
            });
        },
        resetCancel(formName) {
            this.$refs[formName].resetFields();
            this.$refs[formName].clearValidate();
            this.dialogCancelVisible = false;
        },
        // 到店确认
        confirmArrive(data, index) {
            this.$util
                .axiosPost({
                    url: 'api/CustomerManagement/ArriveEntpConfirm',
                    data: {
                        RId: data.RId,
                        ReservationCode: data.ReservationCode,
                        Operator: this.userMsg.EmployeeId,
                        DeviceId: '122333'
                    }
                })
                .then(() => {
                    this.tableData[index].IsArrived = true;
                    this.getTableData();
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //查看取消原因
        viewClosedReason(rrid) {
            this.reasonDialogVisible = true;
            this.formloading = true;
            this.$util
                .axiosGet({
                    url: '/api/CustomerManagement/GetRRCancelReason?rrid=' + rrid,
                    hideLoading: true
                })
                .then(result => {
                    if (result.errcode == 0) {
                        this.reasonFormData = result.data;
                    }
                    this.formloading = false;
                })
                .catch(err => {
                    this.reasonFormData = {};
                    this.formloading = false;
                });
        },
        addReservation() {
            this.editData = {};
            this.dialogVisible = true;
        },
        closeDialog(edit) {
            this.dialogVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        // 车主选择
        carOwnerChooseItem(item) {
            this.showCarOwnerEdit = item.CId !== '';
            this.carOwnerData = item;
        },
        // 新增企业车主
        addCarOwner(type) {
            this.updateCarOwnerId = type;
            this.carOwnerTitle = type * 1 === 1 ? '新增车主' : '编辑车主';
            this.carOwnerVisible = true;
        },
        closeCarOwnerDialog(edit) {
            this.carOwnerVisible = false;
            if (edit) {
                this.$refs.addReservation.getcarOwner('', { type: 'isEdit', value: this.carOwnerData.CId });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.add-reservation {
    position: relative;
    .operator {
        position: absolute;
        top: 12px;
        right: 58px;
    }
}
</style>
